import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiGetPurchaseTermsRequest extends ApiRequestor {
  async $get(organizationId) {
    return this.$http('GET', 'tickets/purchase-terms', {params: {organizationId}})
  }
}
